import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ButtonSizes from './ButtonSizes';
import ClientProvider from './client';
export default createDemo(import.meta.url, ButtonSizes, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/sizes/ButtonSizes.tsx",
    "fileName": "ButtonSizes.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\n\nexport default function ButtonSizes() {\n  return (\n    <Box sx={{ '& button': { m: 1 } }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <div>\n        <Button size=\"small\">Small</Button>\n        <Button size=\"medium\">Medium</Button>\n        <Button size=\"large\">Large</Button>\n      </div>\n      <div>\n        <Button variant=\"outlined\" size=\"small\">\n          Small\n        </Button>\n        <Button variant=\"outlined\" size=\"medium\">\n          Medium\n        </Button>\n        <Button variant=\"outlined\" size=\"large\">\n          Large\n        </Button>\n      </div>\n      <div>\n        <Button variant=\"contained\" size=\"small\">\n          Small\n        </Button>\n        <Button variant=\"contained\" size=\"medium\">\n          Medium\n        </Button>\n        <Button variant=\"contained\" size=\"large\">\n          Large\n        </Button>\n      </div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\n\nexport default function ButtonSizes() {\n  return (\n    <Box sx={{ '& button': { m: 1 } }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <div>\n        <Button size=\"small\">Small</Button>\n        <Button size=\"medium\">Medium</Button>\n        <Button size=\"large\">Large</Button>\n      </div>\n      <div>\n        <Button variant=\"outlined\" size=\"small\">\n          Small\n        </Button>\n        <Button variant=\"outlined\" size=\"medium\">\n          Medium\n        </Button>\n        <Button variant=\"outlined\" size=\"large\">\n          Large\n        </Button>\n      </div>\n      <div>\n        <Button variant=\"contained\" size=\"small\">\n          Small\n        </Button>\n        <Button variant=\"contained\" size=\"medium\">\n          Medium\n        </Button>\n        <Button variant=\"contained\" size=\"large\">\n          Large\n        </Button>\n      </div>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 36,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
